/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Discard_Start_BodyInputs */

const en_us2_offline_discard_start_body = /** @type {(inputs: Offline_Discard_Start_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workout start will not be sent. Its sets will not sync either, and each one will ask you the same.`)
};

const pt_br2_offline_discard_start_body = /** @type {(inputs: Offline_Discard_Start_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O início do treino não será enviado. As séries dele também não vão sincronizar, e cada uma vai perguntar o mesmo.`)
};

const es_419_offline_discard_start_body = /** @type {(inputs: Offline_Discard_Start_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El inicio del entrenamiento no se enviará. Sus series tampoco se sincronizarán, y cada una te preguntará lo mismo.`)
};

const pt_pt2_offline_discard_start_body = /** @type {(inputs: Offline_Discard_Start_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O início do treino não será enviado. As séries dele também não vão sincronizar, e cada uma vai perguntar o mesmo.`)
};

const fr_fr2_offline_discard_start_body = /** @type {(inputs: Offline_Discard_Start_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le début de séance ne sera pas envoyé. Ses séries ne seront pas synchronisées non plus, et chacune te posera la même question.`)
};

const de_de2_offline_discard_start_body = /** @type {(inputs: Offline_Discard_Start_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Trainingsbeginn wird nicht gesendet. Seine Sätze werden dann auch nicht synchronisiert, und bei jedem wirst du dasselbe gefragt.`)
};

const it_it2_offline_discard_start_body = /** @type {(inputs: Offline_Discard_Start_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'inizio dell'allenamento non verrà inviato. Nemmeno le sue serie verranno sincronizzate, e ognuna ti chiederà la stessa cosa.`)
};

/**
* | output |
* | --- |
* | "The workout start will not be sent. Its sets will not sync either, and each one will ask you the same." |
*
* @param {Offline_Discard_Start_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_discard_start_body = /** @type {((inputs?: Offline_Discard_Start_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Discard_Start_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_discard_start_body(inputs)
	if (locale === "es-419") return es_419_offline_discard_start_body(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_discard_start_body(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_discard_start_body(inputs)
	if (locale === "de-DE") return de_de2_offline_discard_start_body(inputs)
	if (locale === "it-IT") return it_it2_offline_discard_start_body(inputs)
	return en_us2_offline_discard_start_body(inputs)
});
export { offline_discard_start_body as "offline.discard_start_body" }